export const options = {
  fbrf: {
    file: [
      {
        optionName: 'Citation Manager (RIS)',
        action: 'CM',
      },
    ],
  },
}
